export const threatmodelClear = 'THREATMODEL_CLEAR';
export const threatmodelContributorsUpdated = 'THREATMODEL_CONTRIBUTORS_UPDATED';
export const threatmodelCreate = 'THREATMODEL_CREATE';
export const threatmodelDiagramClosed = 'THREATMODEL_DIAGRAM_CLOSED';
export const threatmodelDiagramModified = 'THREATMODEL_DIAGRAM_MODIFIED';
export const threatmodelDiagramSaved = 'THREATMODEL_DIAGRAM_SAVED';
export const threatmodelDiagramSelected = 'THREATMODEL_DIAGRAM_SELECTED';
export const threatmodelExportTmbom = 'THREATMODEL_EXPORT_TMBOM';
export const threatmodelFetch = 'THREATMODEL_FETCH';
export const threatmodelFetchAll = 'THREATMODEL_FETCH_ALL';
export const threatmodelLoadDemos = 'THREATMODEL_LOAD_DEMOS';
export const threatmodelModified = 'THREATMODEL_MODIFIED';
export const threatmodelNotModified = 'THREATMODEL_NOT_MODIFIED';
export const threatmodelRestore = 'THREATMODEL_RESTORE';
export const threatmodelSave = 'THREATMODEL_SAVE';
export const threatmodelSelected = 'THREATMODEL_SELECTED';
export const threatmodelStash = 'THREATMODEL_STASH';
export const threatmodelUpdate = 'THREATMODEL_UPDATE';

export default {
    clear: threatmodelClear,
    contributorsUpdated: threatmodelContributorsUpdated,
    create: threatmodelCreate,
    diagramClosed: threatmodelDiagramClosed,
    diagramModified: threatmodelDiagramModified,
    diagramSaved: threatmodelDiagramSaved,
    diagramSelected: threatmodelDiagramSelected,
    exportTmBom: threatmodelExportTmbom,
    fetch: threatmodelFetch,
    fetchAll: threatmodelFetchAll,
    loadDemos: threatmodelLoadDemos,
    modified: threatmodelModified,
    notModified: threatmodelNotModified,
    restore: threatmodelRestore,
    saveModel: threatmodelSave,
    selected: threatmodelSelected,
    stash: threatmodelStash,
    update: threatmodelUpdate
};
